/** @owner shared — UI. Global modal state used across all features. */
import { create } from "zustand";
import type { ReactNode } from "react";

export interface ModalOptions {
  hideBackdrop?: boolean;
  backdropZIndex?: number;
  disableBackdropClick?: boolean;
  allowOverflow?: boolean;
  ariaLabelledBy?: string;
}

interface ModalStore {
  isModalOpen: boolean;
  Content: ReactNode | null;
  options?: ModalOptions;
  openModal: (content: ReactNode, options?: ModalOptions) => void;
  closeModal: () => void;
}

export const useModalStore = create<ModalStore>((set) => ({
  isModalOpen: false,
  Content: null,
  openModal: (content, options) => set({ isModalOpen: true, Content: content, options }),
  closeModal: () => set({ isModalOpen: false, Content: null }),
}));
